import React, { useMemo } from "react";
import { NavLink, Redirect, Route, Switch, useParams } from "react-router-dom";
import PrivateRoute from "@common/components/route/PrivateRoute";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import SmartFitnessBandOverview from "@icoach/smartFitnessBand/overview/SmartFitnessBandOverview";
import TabsCardLayout from "@icoach/components/layout/TabsCardLayout";
import useTabState from "@util/hook/useTabState";

const SmartFitnessBandPage = (props, ref) => {
	const { subTabs } = useParams();
	const { activeTab, handleTabChange } = useTabState(subTabs);
	// const dialogRef = useRef(null);
	// const refreshRef = useRef(null);

	const tabsData = useMemo(
		() => {
			return [
				{
					label: "租賃總覽",
					value: "overview",
					component: NavLink,
					to: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.GET_TABS_PATH("overview"),
				},
			];
		},
		// eslint-disable-next-line
		[]
	);

	const actionsData = useMemo(
		() => {
			const actionMap = {
				overview: [{ label: "新增租約", component: NavLink, to: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_PATH(0) }],
			};
			return actionMap[activeTab];
		},
		// eslint-disable-next-line
		[activeTab]
	);

	return (
		<TabsCardLayout tabs={tabsData} activeTab={activeTab} onTabChange={handleTabChange} tabsContent={{ className: "py-3 px-4" }} actions={actionsData}>
			<Switch>
				<PrivateRoute key="健身環合約" exact={true} path={CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.PAGE} as={SmartFitnessBandOverview} />
				<Route path="/">
					<Redirect to={CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.GET_TABS_PATH("overview")} />
				</Route>
			</Switch>
		</TabsCardLayout>
	);
};

export default SmartFitnessBandPage;
